

import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {deleteQingGuanList, getDocumentsList, uploadDocuments} from "@/api/booking-order";

@Component({
  components: {
    name: DeclDocument
  }
})
export default class DeclDocument extends Vue {
  @Prop({default: false}) private show: boolean;
  @Prop({default: "清关资料"}) private title: "";
  @Prop({default: ''}) private bookingOrderId: {} | any;

  @Watch("show", {immediate: true})
  private watchData() {
    if (this.show) {
      this.getList();
    }
  }

  private documents: Document[] = [];

  private async getList() {
    const res: any = await getDocumentsList(this.bookingOrderId);
    this.documents = res;
  }

  private selectedRows: Document[] = [];

  /**
   * 下载
   * @private
   */
  private async downloadQingGuan(row) {
    let url = row.url;
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('下载失败');

      // 从 Content-Disposition 或 URL 中提取真实文件名
      let filename = 'download.rar'; // 默认值
      const contentDisposition = response.headers.get('Content-Disposition');
      if (contentDisposition) {
        filename = contentDisposition.split('filename=')[1].replace(/"/g, '');
      } else {
        const urlObj = new URL(url);
        filename = decodeURIComponent(urlObj.pathname.split('/').pop());
      }

      // 将文件流转换为 Blob 并触发下载
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename; // 使用OSS提供的正确文件名
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl); // 释放内存
    } catch (error) {
      console.error('下载错误:', error);
    }
  }

  /**
   * 选中的行
   * @private
   */
  private handleSelectionChange(val: Document[]) {
    this.selectedRows = val;
  }

  /**
   * 删除
   * @private
   */
  private async deleteQingGuan() {
    this.buttonLoading = true;
    if (this.selectedRows.length === 0) {
      this.buttonLoading = false;
      return;
    }
    let ids = this.selectedRows.map(row => row.documentId);
    const params = ids.map(id => `ids=${id}`).join("&");
    await deleteQingGuanList(params);
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.clearSelected();
    this.buttonLoading = false;
    await this.getList();
  }

  private clearSelected() {
    this.selectedRows = [];
    // 这里清空勾选项。
    let clearSelection = this.$refs.multipleTable as any;
    clearSelection.clearSelection();
  }

  /**
   * 调起上传窗口
   * @private
   */
  private async handlerClick() {
    this.$refs["uploadPL"]["$refs"]["upload-inner"].handleClick();
  }

  private files: File[] = [];

  /**
   * 批量上传，添加文件
   * @param file
   * @private
   */
  private addFile(file: File) {
    const isLimit = file.size / 1024 / 1024 < 10;
    if (!isLimit) {
      this.$message.error(`上传文件大小不能超过10MB!`);
      return;
    }
    this.files.push(file);
  }

  /**
   * 上传
   * @private
   */
  private async upload() {
    let formData = new window.FormData();
    formData.append("files", this.files.pop());
    await uploadDocuments(this.bookingOrderId, formData);
    this.$notify({
      title: "成功",
      message: "上传成功",
      type: "success",
      duration: 2000,
    });
    await this.getList();
  }

  /**
   * 关闭事件
   * @private
   */
  private close() {
    this.$emit("update:show", false);
  }

  private buttonLoading = false;
}

class Document {
  documentId: string;
  fileName: string;
  url: string;
  createdTime: Date;
  remark: string;
  uploader: string;
}
